import { Component } from '@angular/core';
import { AwarenessFacade } from '@modules/awareness/awareness.facade';

@Component({
	selector: 'rx-awareness-banner-ga',
	templateUrl: './awareness-banner-ga.component.html'
})
export class AwarenessBannerGaComponent {
	constructor(private awarenessFacade: AwarenessFacade) {}

	get isProcedureFlow(): boolean {
		return this.awarenessFacade.isProcedureFlow;
	}
}
